"use client"
import "@/components/header/header.css"
import { LANGUAGE_CONFIG } from "@/constants/languageConfig";
import { EXPOSURE_RECORD, sendClickTrack } from "@/tracks/25061";
import Customise from "@/components/header/components/customise";
import { EXPCONFIG_FAST } from "@/common-components-src/const/point";
import LangSVG from "@/assets/icons/lang-white.svg";
import ArrowDown from "@/assets/icons/arrow-down.svg";

interface Props{
  displayName: string
}

const LanguageLogo = ({ displayName }: Props) => {

  return (
    <div className={`country-wrap display-flex`}>
      <button
        className="country-current display-flex"
        exptag={"exp|" + EXPOSURE_RECORD.Header_Country_Expo}
        data-exptag-config={EXPCONFIG_FAST}
        onClick={sendClickTrack.Header_Country}
      >
        <LangSVG />
        <span className="country">{displayName}</span>
        <ArrowDown className="arrow-down" />
      </button>
      <div className="country-list-dropdown-layer">
        { LANGUAGE_CONFIG && <Customise type={0}/> }
      </div>
    </div>
  )
}

export default LanguageLogo;